'use strict';

module.exports = cmp;

function cmp(a, b) {
  return a[0].mul(b[1]).cmp(b[0].mul(a[1]));
}